import { Provider } from '@angular/core';

import { RoomAdaptApiService } from '../api';

import { NoopRoomAdaptApiService } from './noop-room-adapt-api.service';

export function provideRoomAdaptDataAccessNoop(): Provider[] {
	return [{ provide: RoomAdaptApiService, useClass: NoopRoomAdaptApiService }];
}
